import getValidSubmissions from "@/containers/E4ImpactMBA/helpers/getValidSubmissions";
import {COLORS} from "@/utils/constants";

export const transformData = [
    {
        name: 'Business modeling skills',
        key: 'bizmodel',
    },
    {
        name: 'Sustainability and impact measurement skills',
        key: 'impact',
    },
    {
        name: 'Pitching skills',
        key: 'pitch',
    },
    {
        name: 'Financial-economic planning and accountability skills',
        key: 'finance',
    },
    {
        name: 'Marketing',
        key: 'marketing',
    },
    {
        name: 'Design & Product Development',
        key: 'product',
    },
];

export const baselineStructure = {
    bizmodel: 'skills_t0_bizmodel_skills_t0',
    impact: 'skills_t0_impact_skills_t0',
    pitch: 'skills_t0_pitch_skills_t0',
    finance: 'skills_t0_finance_skills_t0',
    marketing: 'skills_t0_marketing_skills_t0',
    product: 'skills_t0_product_skills_t0',
}

export const finalStructure = {
    bizmodel: 'question8_bizmodel_skills_t1',
    impact: 'question8_impact_skills_t1',
    pitch: 'question8_pitch_skills_t1',
    finance: 'question8_finance_skills_t1',
    marketing: 'question8_mkt_skills_t2',
    product: '',
}

export const calculateTotalByKeyAndStructure = (submissions: any[], structure: any, key: string): number => {
    const total = submissions.reduce(
        (acc: number, submission: any) => acc + Number((submission[structure[key]] || 0)), 0
    );

    return total / submissions.length;
}

/**
 * question: Regarding the topics below, how would you rate your level of knowledge on a scale from 1 (very low) to 7 (very high)?
 * == baseline
 * skills_t0_bizmodel_skills_t0
 * skills_t0_impact_skills_t0
 * skills_t0_pitch_skills_t0
 * skills_t0_finance_skills_t0
 * skills_t0_marketing_skills_t0
 * skills_t0_product_skills_t0
 * 
 * == final
 * question8_bizmodel_skills_t1
 * question8_impact_skills_t1
 * question8_pitch_skills_t1
 * question8_finance_skills_t1
 * question8_mkt_skills_t2
 * 
 * @param props 
 * @returns 
 */
export const increasedSkillsChartCalculation = (props: any) => {
    const {filteredBaseline, filteredFinal} = getValidSubmissions(
        props.baselineSubmissions,
        props.finalSubmissions
    );

    const baselineData = transformData.map(
        ({name, key}) => ({
            name,
            y: +calculateTotalByKeyAndStructure(filteredBaseline, baselineStructure, key).toFixed(2)
        })
    );
    const finalData = transformData.map(
        ({name, key}) => ({
            name,
            y: +calculateTotalByKeyAndStructure(filteredFinal, finalStructure, key).toFixed(2)
        })
    );

    return {
        chart: {
            type: 'bar',
            style: {
                fontFamily: 'Rubik, sans-serif',
            },
            backgroundColor: '#fafafa',
        },
        xAxis: {
            categories: transformData.map(({name}) => name),
        },
        yAxis: {
            tickInterval: 1,
            min: 1,
            max: 7,
        },
        legend: {
            verticalAlign: 'top',
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true,
                },
                groupPadding: 0.1,
            },
        },
        title: {
            text: 'Increased skills',
            align: 'left',
        },
        series: [
            {
                type: 'column',
                name: 'BASELINE',
                data: baselineData,
                color: COLORS.blue,
            },
            {
                type: 'column',
                name: 'FINAL',
                data: finalData,
                color: COLORS.yellow,
            },
        ],
    } as Highcharts.Options;
}